// import React from "react";

// const LoadingSpinner = () => {
//   return (
//     <div className="flex items-center justify-center min-h-[60vh]">
//       <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-[#FF4C18]"></div>
//     </div>
//   );
// };

// export default LoadingSpinner;

import React from "react";

const LoadingSpinner = ({ size = 16, color = "#FF4C18" }) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div
        className="animate-spin rounded-full border-t-4 border-b-4"
        style={{
          width: `${size * 4}px`,
          height: `${size * 4}px`,
          borderColor: `${color} transparent ${color} transparent`,
        }}
      />
    </div>
  );
};

export default LoadingSpinner;
